/**
 * Centralized query keys for Clearance feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const ORGANIZATION_CLEARANCE_LIST_QUERY_KEY = 'organization-clearance-list';
export const CLEARANCE_QUERY_KEY = 'clearance';
export const CLEARANCE_NOTES_QUERY_KEY = 'clearance-notes';
export const CLEARANCE_STATUS_HISTORY_QUERY_KEY = 'clearance-status-history';
export const CLEARANCE_CHANGE_HISTORY_QUERY_KEY = 'clearance-change-history';
